
import Vue from 'vue';
import { AgrFeedbackPopup } from '@agrial/ui';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Footer',
  components: {
    AgrFeedbackPopup
  },
  data () {
    return {
      forceFeedbackView: false
    };
  },
  computed: {
    ...mapGetters({ versions: 'infos/versions' })
  },
  methods: {
    forceFeedback () {
      this.forceFeedbackView = true;
    }
  }
});
